import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'guestTitleInput',
    'guestFirstNameInput',
    'guestLastNameInput',
    'bookerTitleInput',
    'bookerFirstNameInput',
    'bookerLastNameInput'
  ]

  updateBookerTitle() {
    this.bookerTitleInputTarget.value = this.guestTitleInputTarget.value
  }

  updateBookerFirstName() {
    this.bookerFirstNameInputTarget.value = this.guestFirstNameInputTarget.value
  }

  updateBookerLastName() {
    this.bookerLastNameInputTarget.value = this.guestLastNameInputTarget.value
  }
}
